import { TemplateKind } from '../Model/TemplateKind';
import { WidgetType } from '../Model/WidgetType';
var StaticPaneManager = /** @class */ (function () {
    function StaticPaneManager(pane) {
        this._pane = null;
        this._slots = [];
        this._pane = pane;
        this._slots = [
            null
        ];
    }
    StaticPaneManager.prototype.show = function (widget, position, showCb) {
        // Get slot and render
        this.takeSlot(widget, position);
        var templateKind = TemplateKind.Static;
        // HYPONLINE-91
        if (widget.widget && widget.widget.type == WidgetType.RatePlan && widget.widget.widgetType == WidgetType.Comparer) {
            templateKind = TemplateKind.Comparer;
        }
        var content = widget.render(templateKind);
        var params = {
            kind: TemplateKind.Static,
            position: position,
            priority: 1
        };
        this._pane.show(params, content, showCb);
    };
    StaticPaneManager.prototype.hide = function (widget, position) {
        this.freeSlot(widget, position);
        var params = {
            kind: TemplateKind.Static,
            position: position
        };
        this._pane.hide(params);
    };
    StaticPaneManager.prototype.destroy = function (position) {
        this._slots = [
            null
        ];
        var params = {
            kind: TemplateKind.Static,
            position: position
        };
        this._pane.destroy(params);
    };
    StaticPaneManager.prototype.findSlotIndex = function (position, widget) {
        var slotIndex = this._slots.indexOf(widget);
        if (slotIndex > -1) {
            return slotIndex;
        }
        return null;
    };
    StaticPaneManager.prototype.takeSlot = function (widget, position) {
        var emptySlotIndex = this.findSlotIndex(position, null);
        if (emptySlotIndex !== null) {
            this._slots[emptySlotIndex] = widget;
        }
    };
    StaticPaneManager.prototype.freeSlot = function (widget, position) {
        var widgetSlotIndex = this.findSlotIndex(position, widget);
        if (widgetSlotIndex !== null) {
            this._slots[widgetSlotIndex] = null;
        }
    };
    StaticPaneManager.prototype.hasEmptySlot = function (position) {
        return this.findSlotIndex(position, null) !== null;
    };
    return StaticPaneManager;
}());
export { StaticPaneManager };
